import React from 'react';
import CountUp from 'react-countup';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const DashboardWidgets = ({ dataWidget, office, loading, isShow }) => {
  const WidgetsView = () => {
    return (
      <Row>
        <Col xl={12}>
          <Card className="crm-widget">
            <CardBody className="p-0">
              <Row className="row-cols-md-3 row-cols-1">
                <Col className="col-lg">
                  <div className="mt-3 mt-md-0 py-3 px-3">
                    <h5 className="text-muted text-uppercase fs-14">
                      Propostas Ativas
                    </h5>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <i
                          className={'display-6 text-muted ri-file-user-line'}
                        ></i>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h2 className="mb-0">
                          <span className="counter-value">
                            <CountUp
                              start={0}
                              end={dataWidget && dataWidget.resume.active}
                              decimals={0}
                              duration={2}
                              formattingFn={(value) =>
                                value.toLocaleString(
                                  undefined, // leave undefined to use the visitor's browser
                                  // locale or a string like 'en-US' to override it.
                                  { minimumFractionDigits: 0 }
                                )
                              }
                            />
                          </span>
                        </h2>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end border-top border-top-dashed">
                      <Link
                        to={{
                          pathname: '/propostas/active',
                          state: office,
                        }}
                        className="link-primary pt-2 pe-1"
                      >
                        Ver mais{' '}
                        <i className="ri-arrow-right-line align-middle"></i>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col className={'col-lg'}>
                  <div className="mt-3 mt-md-0 py-3 px-3">
                    <h5 className="text-muted text-uppercase fs-14">
                      Propostas Novas
                    </h5>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <i
                          className={'display-6 text-muted ri-file-add-line'}
                        ></i>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h2 className="mb-0">
                          <span className="counter-value">
                            <CountUp
                              start={0}
                              end={dataWidget && dataWidget.resume.news}
                              decimals={0}
                              duration={2}
                              formattingFn={(value) =>
                                value.toLocaleString(
                                  undefined, // leave undefined to use the visitor's browser
                                  // locale or a string like 'en-US' to override it.
                                  { minimumFractionDigits: 0 }
                                )
                              }
                            />
                          </span>
                        </h2>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end border-top border-top-dashed">
                      <Link
                        to={{
                          pathname: '/propostas/news',
                          state: office,
                        }}
                        className="link-primary pt-2 pe-1"
                      >
                        Ver mais{' '}
                        <i className="ri-arrow-right-line align-middle"></i>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col className={'col-lg'}>
                  <div className="mt-3 mt-md-0 py-3 px-3">
                    <h5 className="text-muted text-uppercase fs-14">
                      Propostas Vencidas
                    </h5>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <i
                          className={'display-6 text-muted ri-article-line'}
                        ></i>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h2 className="mb-0">
                          <span className="counter-value">
                            <CountUp
                              start={0}
                              end={dataWidget && dataWidget.resume.expired}
                              decimals={0}
                              duration={2}
                              formattingFn={(value) =>
                                value.toLocaleString(
                                  undefined, // leave undefined to use the visitor's browser
                                  // locale or a string like 'en-US' to override it.
                                  { minimumFractionDigits: 0 }
                                )
                              }
                            />
                          </span>
                        </h2>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end border-top border-top-dashed">
                      <Link
                        to={{
                          pathname: '/propostas/expired',
                          state: office,
                        }}
                        className="link-primary pt-2 pe-1"
                      >
                        Ver mais{' '}
                        <i className="ri-arrow-right-line align-middle"></i>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col className={'col-lg'}>
                  <div className="mt-3 mt-md-0 py-3 px-3">
                    <h5 className="text-muted text-uppercase fs-14">
                      Propostas Vencidas este mês
                    </h5>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <i
                          className={'display-6 text-muted ri-archive-line'}
                        ></i>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h2 className="mb-0">
                          <span className="counter-value">
                            <CountUp
                              start={0}
                              end={
                                dataWidget && dataWidget.resume.expiredThisMonth
                              }
                              decimals={0}
                              duration={2}
                              formattingFn={(value) =>
                                value.toLocaleString(
                                  undefined, // leave undefined to use the visitor's browser
                                  // locale or a string like 'en-US' to override it.
                                  { minimumFractionDigits: 0 }
                                )
                              }
                            />
                          </span>
                        </h2>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end border-top border-top-dashed">
                      <Link
                        to={{
                          pathname: '/propostas/expired-month',
                          state: office,
                        }}
                        className="link-primary pt-2 pe-1"
                      >
                        Ver mais{' '}
                        <i className="ri-arrow-right-line align-middle"></i>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col className={'col-lg'}>
                  <div className="mt-3 mt-md-0 py-3 px-3">
                    <h5 className="text-muted text-uppercase fs-14">
                      Propostas A Vencer este mês
                    </h5>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <i className={'display-6 text-muted ri-bill-line'}></i>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h2 className="mb-0">
                          <span className="counter-value">
                            <CountUp
                              start={0}
                              end={
                                dataWidget && dataWidget.resume.expiresThisMonth
                              }
                              decimals={0}
                              duration={2}
                              formattingFn={(value) =>
                                value.toLocaleString(
                                  undefined, // leave undefined to use the visitor's browser
                                  // locale or a string like 'en-US' to override it.
                                  { minimumFractionDigits: 0 }
                                )
                              }
                            />
                          </span>
                        </h2>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end border-top border-top-dashed">
                      <Link
                        to={{
                          pathname: '/propostas/to-expire',
                          state: office,
                        }}
                        className="link-primary pt-2 pe-1"
                      >
                        Ver mais{' '}
                        <i className="ri-arrow-right-line align-middle"></i>
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  };

  return loading ? (
    <Col xs={12} md={12} lg={12}>
      <Card className="crm-widget">
        <SkeletonTheme baseColor="#8B919F">
          <Row className="p-1">
            <div className="text-center">
              <Skeleton height={130} />
            </div>
          </Row>
        </SkeletonTheme>
      </Card>
    </Col>
  ) : isShow ? (
    <Col xs={12} md={12} lg={12}>
      <WidgetsView />
    </Col>
  ) : null;
};
